import React, { Component } from "react";
import { LoadingContainer, LoadingAnimator } from "./styles";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';

class LoadingStatus extends Component {
    render() {
            return <LoadingContainer className="loading-container" style={this.props.loadingData.loading ? {} : {display: 'none'}}>
                <LoadingAnimator className="loading-animate" type="spinningBubbles" color="#000" height={100} width={100} />
            </LoadingContainer>
    }
}


const mapStateToProps = store => ({
    loadingData: store.loadingState
  });
  
export default connect(mapStateToProps) (withRouter(LoadingStatus));
